"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildTimeOptions = exports.buildArray = exports.addInterval = exports.validateStartAndEndHour = void 0;
var tslib_1 = require("tslib");
var fp_1 = require("date-fns/fp");
var pipe_1 = tslib_1.__importDefault(require("lodash/fp/pipe"));
exports.validateStartAndEndHour = function (startHour, endHour) {
    if (startHour >= 0 &&
        startHour <= 24 &&
        endHour >= 0 &&
        endHour <= 24 &&
        startHour < endHour) {
        return true;
    }
    return false;
};
exports.addInterval = function (dates, interval) {
    var date = new Date(dates[dates.length - 1]);
    date.setMinutes(date.getMinutes() + interval);
    dates.push(date);
};
exports.buildArray = function (interval, startHour, endHour) {
    var times = [];
    var now = new Date();
    var current = startHour === 0
        ? fp_1.startOfDay(now)
        : pipe_1.default(fp_1.setHours(startHour), fp_1.startOfHour)(now);
    var end = endHour === 24
        ? fp_1.endOfDay(now)
        : pipe_1.default(fp_1.setHours(endHour), fp_1.startOfHour, fp_1.addMinutes(1))(now);
    while (fp_1.isBefore(end, current)) {
        times.push(current);
        current = fp_1.addMinutes(interval, current);
    }
    return times;
};
exports.buildTimeOptions = function (interval, startHour, endHour) {
    if (interval === void 0) { interval = 60; }
    if (startHour === void 0) { startHour = 0; }
    if (endHour === void 0) { endHour = 24; }
    if (!exports.validateStartAndEndHour(startHour, endHour)) {
        startHour = 0;
        endHour = 24;
    }
    var dates = exports.buildArray(interval, startHour, endHour);
    var times = dates.map(function (date) {
        return {
            value: date,
            label: date.toLocaleTimeString([], {
                hour: 'numeric',
                minute: 'numeric',
            }),
        };
    });
    return times;
};
